<template>
    <div class="block-bid-incognito" v-if="checkStateAuction == 4 || (checkStateAuction == 5 && checkAvailableTime)">
        <div class="block-bid">
            <div class="block-time-end">
                <div class="block-top">
                    <div class="text">残り時間</div>
                    <div class="time-end">
                        <span class="number">{{ timeEnd }}</span>
                        <span class="second">second</span>
                    </div>
                </div>
                <div class="block-triangle">
                    <div class="triangle-bottom"></div>
                </div>
            </div>
            <div class="block-sm">
                <div class="block-current-price">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount : product.bid_start_price)
                                    }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount * 1.21 : product.bid_start_price * 1.21)
                                    }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="sold-out" v-if="bidTop && bidTop.amount > product.lowest_winning_price">売り切り</div>
                    <div class="tag">現在価格</div>
                    <div class="triangle"></div>
                </div>
                <div class="block-noti">
                    <div class="text-updated"
                         v-if="checkBidTop == 'type1'">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>現在価格であなたがTOP入札中</span>
                    </div>
                    <div class="text-updated"
                         v-else-if="checkBidTop == 'type2'">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>現在価格で入札中 最低価格に達していません</span>
                    </div>
                    <div class="text-updated" v-else-if="checkBidTop == 'type3' && this.bidTop">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>あなたより他の会員が高値で入札しました</span>
                    </div>
                </div>
                <div class="block-enter-bid">
                    <div class="left">入札額のご入力</div>
                    <div class="right">最低額 {{
                            formatPrice(handlePriceRange(bidTop ? bidTop.amount : product.bid_start_price).priceIncreaseMin)
                        }}JPY
                    </div>
                </div>
                <div class="block-prie-bid">
                    <div class="block-top">
                        <div class="block-input">
                            <input type="text" id="input-bid" class="input-bid" name="bid_incognito"
                                   :placeholder="bidTop ? bidTop.amount / 1000 : product.bid_start_price / 1000"
                                   @input="validateNumberInput()">
                            <div class="thousand">,000 <span class="jpy">JPY</span></div>
                        </div>
                        <button class="btn-send-price btn-sm" @click="storeBidIncognito">入札</button>
                        <button class="btn-clear-price" @click="clearValue()">クリア</button>
                    </div>
                    <div id="errors-price" class="error d-none">現在価格より大きい価格を入力してください。</div>
                    <div class="block-center">
                        <button class="btn-price-up" @click="increaseBidPrice('min')">
                            +{{
                                formatPrice(handlePriceRange(bidTop ? bidTop.amount : product.bid_start_price).priceIncreaseMin)
                            }} <span
                            class="jpy">JPY</span></button>
                        <button class="btn-price-up" @click="increaseBidPrice('max')">
                            +{{
                                formatPrice(handlePriceRange(bidTop ? bidTop.amount : product.bid_start_price).priceIncreaseMax)
                            }} <span
                            class="jpy">JPY</span></button>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large" @click="storeBidIncognito">この価格で入札する</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-history">
            <div class="text-history">入札履歴</div>
            <div class="history">
                <div class="">
                    <div class="item-history" v-for="history in histories">
                        <div class="left-history">
                            <button class="tag tag-black">事前入札</button>
                        </div>
                        <div class="right-history">
                            <div class="top"><strong>ID: {{ history.member_id }}</strong> {{
                                    formatPrice(history.amount)
                                }} JPY
                            </div>
                            <div class="bottom">{{ formatDate(history.created_at) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="block-bid-incognito" v-else>
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-noti">
                    <div class="text-updated">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>オークション期間は終了しました。</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import CONSTANTS from "../constants";
import moment from "moment-timezone";

export default {
    mounted() {

    },
    async created() {
        await this.getDataBid();

        Echo.channel('bid.incognito.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.incognito.sent', (e) => {
                this.histories.unshift(e.myBid)
                this.bidTop = e.bidTop;
            });

        Echo.channel('bid.incognito.' + this.auction.id)
            .listen('.bid.incognito.start', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 4 && this.auction.state != 4) {
                        this.countDownTime();

                        this.interval = setInterval(() => {
                            this.countDownTime();
                        }, 1000);
                    }
                }
            });

        Echo.channel('bid.incognito.' + this.auction.id)
            .listen('.bid.incognito.end', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 5 && !this.checkAvailableTime) {
                        window.location.href = `/auction/${this.auction.id}/detail`;
                    }
                }
            });

        if ((this.checkStateAuction == 4 && this.auction.state == 4) || (this.checkStateAuction == 5 && this.checkAvailableTime)) {
            this.countDownTime();

            this.interval = setInterval(() => {
                this.countDownTime();
            }, 1000);
        }

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.setting.product_end_time', (e) => {
                if (this.auction.id == e.auction.id) {
                    window.location.reload();
                }
            });
    },
    props: [
        'product',
        'auction',
        'product_auction'
    ],
    data: function () {
        return {
            timeEnd: null,
            interval: null,
            bidTop: null,
            myBidTop: null,
            member: null,
            histories: null,
            checkStateAuction: this.auction.state,
            checkProductAuction: this.product_auction,
        }
    },
    methods: {
        async getDataBid() {
            await axios.post('/bid/get-data-bid-incognito', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.bidTop = res.data.bidTop;
                    this.member = res.data.member;
                    this.histories = res.data.histories;
                    this.myBidTop = res.data.myBidTop;
                })
                .catch(error => {

                })
        },

        async getAuctionProduct() {
            await axios.post('/bid/get-data-auction-product', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.checkProductAuction = res.data.auctionProduct;
                })
                .catch(error => {

                })
        },

        async storeBidIncognito() {
            if ((this.checkStateAuction == 4 || (this.checkStateAuction == 5 && this.checkAvailableTime)) &&
                this.checkBidPermission() == CONSTANTS.CAN_BID) {
                let amount = document.getElementsByClassName('input-bid')[0].value * 1;
                this.clearValue();

                if (!document.getElementById('errors-price').classList.contains('d-none')) {
                    document.getElementById('errors-price').classList.add('d-none')
                }

                if (this.bidTop) {
                    if (amount && this.bidTop && amount * 1000 > this.bidTop.amount) {
                        await axios.post('/bid/store-incognito', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: amount * 1000,
                        })
                            .then(response => {
                                if (response.data.myBidTop) {
                                    this.myBidTop = response.data.myBidTop;
                                }
                            })
                            .catch(error => {
                                if(error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                }
                            })
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                } else {
                    if (amount && amount * 1000 > this.product.bid_start_price) {
                        await axios.post('/bid/store-incognito', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: amount * 1000,
                        })
                            .then(response => {
                                if (response.data.myBidTop) {
                                    this.myBidTop = response.data.myBidTop;
                                }
                            })
                            .catch(error => {
                                if(error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                }
                            })
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                }
            } else {
                switch (this.checkBidPermission()) {
                    case CONSTANTS.AUCTION_COMPANY:
                        document.getElementsByClassName('auction-company')[0].classList.remove('d-none');
                        break;
                    case CONSTANTS.NOT_MEMBER:
                        document.getElementsByClassName('not-member')[0].classList.remove('d-none');
                        break;
                    case CONSTANTS.CAN_NOT_BID:
                        document.getElementsByClassName('can-not-bid')[0].classList.remove('d-none');
                        break;
                }
                document.getElementById('input-bid').value = '';
            }
        },

        clearValue() {
            return document.getElementsByClassName('input-bid')[0].value = '';
        },

        formatPrice(price) {
            return price ? price.toLocaleString(undefined, {maximumFractionDigits: 0}) : 0;
        },

        increaseBidPrice(type) {
            let element = document.getElementsByClassName('input-bid')[0];

            if (element.value > 0) {
                if (this.bidTop) {
                    if (type == 'min') {
                        return element.value = element.value * 1 + (this.handlePriceRange(this.bidTop.amount).priceIncreaseMin) / 1000;
                    }

                    return element.value = element.value * 1 + (this.handlePriceRange(this.bidTop.amount).priceIncreaseMax) / 1000;
                } else {
                    if (type == 'min') {
                        return element.value = element.value * 1 + (this.handlePriceRange(this.product.bid_start_price).priceIncreaseMin) / 1000;
                    }

                    return element.value = element.value * 1 + (this.handlePriceRange(this.product.bid_start_price).priceIncreaseMax) / 1000;
                }
            }

            if (this.bidTop) {
                if (type == 'min') {
                    return element.value = (this.bidTop.amount + this.handlePriceRange(this.bidTop.amount).priceIncreaseMin) / 1000;
                }

                return element.value = (this.bidTop.amount + this.handlePriceRange(this.bidTop.amount).priceIncreaseMax) / 1000;
            } else {
                if (type == 'min') {
                    return element.value = (this.product.bid_start_price + this.handlePriceRange(this.product.bid_start_price).priceIncreaseMin) / 1000;
                }

                return element.value = (this.product.bid_start_price + this.handlePriceRange(this.product.bid_start_price).priceIncreaseMax) / 1000;
            }
        },

        handlePriceRange(amountBidTop) {
            let priceIncreaseMin = null;
            let priceIncreaseMax = null;

            if (amountBidTop >= 0 && amountBidTop <= 100000) {
                priceIncreaseMin = 1000;
                priceIncreaseMax = 10000;
            } else if (amountBidTop > 100000 && amountBidTop <= 500000) {
                priceIncreaseMin = 5000;
                priceIncreaseMax = 50000;
            } else if (amountBidTop > 500000 && amountBidTop <= 5000000) {
                priceIncreaseMin = 10000;
                priceIncreaseMax = 100000;
            } else if (amountBidTop > 5000000) {
                priceIncreaseMin = 50000;
                priceIncreaseMax = 500000;
            }

            return {
                priceIncreaseMin: priceIncreaseMin,
                priceIncreaseMax: priceIncreaseMax
            }
        },

        countDownTime() {
            let endTime = this.checkProductAuction.end_bid_incognito_time !== null ?
                this.checkProductAuction.end_bid_incognito_time : this.auction.prebid_end_time;

            let distance = -1;
            let start = new Date(this.auction.prebid_start_time).getTime();
            let end = new Date(endTime).getTime();
            let timeJapan = new Date().toLocaleString("en-US", {timeZone: "Asia/Tokyo"});
            let now = new Date(timeJapan).getTime();

            if (start > now || end < now) {
                distance = -1;
            } else {
                distance = end - now
            }

            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (distance < 0) {
                clearInterval(this.interval);
                return this.timeEnd = "0 : 0 : 0 ";
            }

            return this.timeEnd = (days ? (days + "D - ") : '') + hours + " : " + minutes + " : " + seconds;
        },

        formatDate(time) {
            let date = new Date(time);
            let year = date.getFullYear();
            let month = String(date.getMonth() + 1).padStart(2, "0");
            let day = String(date.getDate()).padStart(2, "0");
            let hours = String(date.getHours()).padStart(2, "0");
            let minutes = String(date.getMinutes()).padStart(2, "0");
            let seconds = String(date.getSeconds()).padStart(2, "0");

            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
        },

        validateNumberInput() {
            let inputElement = document.getElementById('input-bid');
            let inputValue = inputElement.value;
            inputElement.value = inputValue.replace(/[^0-9]/g, '');
        },

        checkBidPermission() {
            if (this.member.type == 1 && this.auction.type == 2) {
                return CONSTANTS.AUCTION_COMPANY;
            }

            if (this.member.status != 1) {
                return CONSTANTS.NOT_MEMBER;
            }

            if (this.member.member_rank_id == 7 || this.member.member_rank_id == 9) {
                return CONSTANTS.CAN_NOT_BID
            }

            return CONSTANTS.CAN_BID
        }
    },
    computed: {
        checkBidTop: function () {
            if (
                this.myBidTop && this.bidTop
                && this.bidTop.member_id == this.member.id
                && this.bidTop.amount >= this.product.lowest_winning_price
            ) {
                return 'type1'
            }

            if (
                this.myBidTop && this.bidTop
                && this.bidTop.member_id == this.member.id
                && this.bidTop.amount < this.product.lowest_winning_price
            ) {
                return 'type2'
            }

            if (
                this.myBidTop && this.bidTop
                && this.bidTop.member_id != this.member.id
            ) {
                return 'type3'
            }

            return null;
        },

        checkAvailableTime: function () {
            if(this.checkProductAuction.end_bid_incognito_time !== null) {
                let productEndPreBid = moment(this.checkProductAuction.end_bid_incognito_time).format('YYYY-MM-DD HH:mm:ss');
                let auctionEndPreBid = moment(this.auction.prebid_end_time).format('YYYY-MM-DD HH:mm:ss');
                let auctionLiveTime = moment(this.auction.start_time).format('YYYY-MM-DD HH:mm:ss');
                let current = moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss');
                if ((productEndPreBid > auctionEndPreBid) &&
                    ((current > auctionEndPreBid) && (current < auctionLiveTime)) &&
                    // (productEndPreBid < auctionLiveTime) &&
                    (productEndPreBid > current)) {
                    return true;
                }
            }

            return false;
        },
    },
}
</script>